import React from 'react';
import { ExternalLink } from 'lucide-react';

import { CrossDockPurchaseOrderActionsMenu } from 'components/logistics/components/crossDockPurchaseOrders/CrossDockPurchaseOrderActionsMenu';
import { Button } from 'shadcn/components/ui/Button';

export function CrossDockPurchaseOrderActionsCell({
    id,
    isCancelDisabled,
    isDownloading,
    onCancel,
    onDownloadPdf,
    onView,
}) {
    return (
        <div className="flex items-center gap-2">
            {onView && (
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    aria-label={`View cross dock purchase order ${id}`}
                    onClick={onView}
                >
                    <ExternalLink className="h-4 w-4" />
                </Button>
            )}
            {onDownloadPdf || onCancel ? (
                <CrossDockPurchaseOrderActionsMenu
                    ariaLabel={`Open actions for cross dock purchase order ${id}`}
                    isCancelDisabled={isCancelDisabled}
                    isDownloading={isDownloading}
                    onCancel={onCancel}
                    onDownloadPdf={onDownloadPdf}
                />
            ) : null}
        </div>
    );
}
